// test825
(825 && 0);
